export default __webpack_public_path__ + "static/media/mute.060a0cc5.png";